import { render, staticRenderFns } from "./PrivacyAgreement.vue?vue&type=template&id=499d954a&scoped=true&"
import script from "./PrivacyAgreement.vue?vue&type=script&lang=ts&"
export * from "./PrivacyAgreement.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyAgreement.vue?vue&type=style&index=0&id=499d954a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499d954a",
  null
  
)

export default component.exports